import { useState } from "react";

import { Input } from "@fragments";

import "./autoplay.scss";

const STORAGE_KEY = "autoplay_enabled";
const CHANGE_EVENT = "autoplay-changed";

export function getAutoplayEnabled() {
    try {
        return localStorage.getItem(STORAGE_KEY) !== "false";
    } catch {
        return true;
    }
}

export function subscribeAutoplayChange(listener) {
    const handler = (e) => listener(!!e.detail?.enabled);
    window.addEventListener(CHANGE_EVENT, handler);
    return () => window.removeEventListener(CHANGE_EVENT, handler);
}

export default function AutoplayToggle() {
    const [enabled, setEnabled] = useState(getAutoplayEnabled);

    function handleChange(value) {
        setEnabled(value);
        try {
            localStorage.setItem(STORAGE_KEY, String(value));
        } catch {}
        window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { enabled: value } }));
    }

    return (
        <div className="autoplay-toggle">
            <Input.Switch
                size="small"
                value={enabled}
                onInput={handleChange}
                label="Reprodução automática"
            />
        </div>
    );
}
